import { Component, OnInit } from '@angular/core';
import { UserDataService } from '../data-storage/user-data.service';
import { Observable } from 'rxjs/Observable';
import { UserDto } from '../../../dtos/userDto';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { PartnerAddressDto } from '../../../dtos/partnerAddressDto';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../services/user.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SitesDataService } from '../data-storage/sites-data.service';
import { SiteDto } from '../../../dtos/siteDto';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { zip } from 'rxjs';
import { merge } from 'rxjs';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-profile-page',
    templateUrl: './profile-page.component.html',
    styleUrls: ['./profile-page.component.scss']
})
export class ProfilePageComponent implements OnInit, AfterViewInit {

    isLoginOpen: boolean;
    navigationStep: number;
    userObservable: Observable<UserDto>;
    basicInfoForm: FormGroup = new FormGroup({
        basicInfo: new FormControl(""),
    });
    billingInfoForm: FormGroup = new FormGroup({
        billingInfo: new FormControl(""),
    });
    userPasswordForm: FormGroup = new FormGroup({
        userPassword: new FormControl(""),
    });
    flowLoading: boolean;
    orders$: Observable<any>;

    private subscriptions: Subscription[] = [];

    constructor(private userDataService: UserDataService, private userService: UserService,
                private sitesDataService: SitesDataService, public globalDataService: GlobalDataService,
                private router: Router, private translate: TranslateService, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.navigationStep = 1;
        this.userObservable = this.userDataService.currentUser;
        this.orders$ = this.userService.getOrders();
        const subscription = this.userDataService.currentUser.subscribe((user: UserDto) => {
            if (!user.id) {
                this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang]);
            }
        })
        this.subscriptions.push(subscription);
    }

    ngAfterViewInit(): void {
        const tabsIndex = {
            general: 1,
            billing: 2,
            password: 3,
            order: 4,
            deleteAccount: 5
        }
        setTimeout(() => {
            this.route.paramMap.subscribe((params) => {
                this.navigationStep = tabsIndex[params.get('tab')] ? tabsIndex[params.get('tab')] : 1;
            })
        }, 100)
    }


    changeView(step) {
        this.navigationStep = step;
    }

    saveInfo(form: FormGroup) {
        if (form.valid) {
            const subscription = this.updateBasicInfo()
                .subscribe(() => {
                    setTimeout(() => {
                        this.flowLoading = false;
                        subscription.unsubscribe();
                        form.markAsPristine();
                    })
                });
            this.flowLoading = true;
        }
    }

    savePassword() {
        if (this.userPasswordForm.valid) {
            Swal.fire({
                title: 'Είστε σίγουροι?',
                text: "Η αλλαγή κωδικού είναι μια μόνιμη ενέργεια που δεν μπορεί να αναιρεθεί.",
                icon: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Αλλαγή',
                cancelButtonText: 'Άκυρο'
            }).then((result) => {
                if (result.value) {
                    const passwordMap: Record<string, string> = {};
                    passwordMap.newPassword = this.userPasswordForm.value.userPassword.newPassword;
                    passwordMap.validationPassword = this.userPasswordForm.value.userPassword.validatePassword;
                    this.userService.updatePassword(passwordMap)
                        .subscribe(() => {
                            Swal.fire(
                                'Αλλαγή κωδικού',
                                'Η αλλαγή κωδικού έγινε με επιτυχία',
                                'success'
                            )
                        })
                }
            })
        }
    }

    getSiteName(siteIds: number[]): Observable<String> {
        let siteObservables = siteIds.map((siteId) => this.sitesDataService.getSiteById(siteId));
        return combineLatest(siteObservables).pipe(
            map((values) => values.map(
                (site: SiteDto) => {
                    if (site) {
                        return this.globalDataService.getObjectTranslation(site.siteTranslations, "name")
                    } else {
                        return '';
                    }
                })
                .join(','))
        );
    }

    goToMeeting(){
        this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/meeting-room']);
    }

    deleteAccount() {
        Swal.fire({
            title: 'Είστε σίγουροι?',
            text: "Πρόκειται να διαγράψετε οριστικά τον λογαριασμό σας όλες οι αγορές σας θα χαθούν.",
            icon: 'warning',
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Διαγραφή',
            cancelButtonText: 'Άκυρο'
        }).then((result) => {
            if (result.value) {
                this.userService.deleteMe().subscribe(() => {
                    this.userService.logout();
                })
            }
        })
    }


    private updateBasicInfo() {
        const currentUser = this.userDataService.getUser();
        const userAddress: PartnerAddressDto = currentUser.addresses.find((el) => el.primary);
        if (this.basicInfoForm.value.basicInfo !== "") {
            currentUser.email = this.basicInfoForm.value.basicInfo.email;
            currentUser.name = this.basicInfoForm.value.basicInfo.name;
            currentUser.lastName = this.basicInfoForm.value.basicInfo.lastName;
            userAddress.phone = this.basicInfoForm.value.basicInfo.phone;
        }

        if (this.billingInfoForm.value.billingInfo !== "") {
            userAddress.street = this.billingInfoForm.value.billingInfo.street;
            userAddress.country = this.billingInfoForm.value.billingInfo.country;
            userAddress.postalCode = Number(this.billingInfoForm.value.billingInfo.postcode);
            userAddress.area = this.billingInfoForm.value.billingInfo.region;
        }
        return this.basicInfoForm.pristine && this.billingInfoForm.pristine ? new BehaviorSubject({}).asObservable() : this.userService.updateMe(currentUser);
    }

}
